import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialFooter from '../components/SocialFooter';
import { ArrowLeft, EnvelopeSimple, ChatCircleDots, Question, Bug, Clock, Lifebuoy } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";

const SUPPORT_ITEMS = [
  {
    icon: ChatCircleDots,
    title: 'General Questions',
    description: 'Have a question about using Track365? We\'re here to help.',
    action: 'mailto:support@track365cardio.com?subject=General%20Question',
    actionLabel: 'Email Support',
  },
  {
    icon: Bug,
    title: 'Report a Bug',
    description: 'Found something broken? Let us know so we can fix it fast.',
    action: 'mailto:support@track365cardio.com?subject=Bug%20Report',
    actionLabel: 'Report Bug',
  },
  {
    icon: Question,
    title: 'Account & Billing',
    description: 'Questions about your subscription, payments, or account settings.',
    action: 'mailto:billing@track365cardio.com?subject=Billing%20Question',
    actionLabel: 'Contact Billing',
  },
  {
    icon: Lifebuoy,
    title: 'Feature Request',
    description: 'Want to see something new? We love hearing from our users.',
    action: 'mailto:support@track365cardio.com?subject=Feature%20Request',
    actionLabel: 'Submit Request',
  },
];

const Support = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="support-screen">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: `url(${LOGO_URL})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '50%' }} />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
            <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
          </button>
          <img src={LOGO_URL} alt="Track365" className="w-40 h-auto" />
          <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Support</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
            How Can We Help?
          </h2>
          <p className="text-muted-foreground">
            Our team typically responds within 24-48 hours.
          </p>
        </div>

        {/* Quick Contact */}
        <div className="premium-card p-5 mb-6 text-center">
          <EnvelopeSimple weight="duotone" className="w-8 h-8 text-[#D4AF37] mx-auto mb-2" />
          <p className="text-sm text-muted-foreground mb-1">Email us directly at</p>
          <a href="mailto:support@track365cardio.com" className="text-lg text-[#D4AF37] font-semibold hover:underline" data-testid="support-email">
            support@track365cardio.com
          </a>
        </div>

        {/* Support Categories */}
        <div className="space-y-4 mb-8">
          {SUPPORT_ITEMS.map((item, idx) => (
            <div key={idx} className="premium-card p-5" data-testid={`support-item-${idx}`}>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                  <item.icon weight="duotone" className="w-6 h-6 text-[#D4AF37]" />
                </div>
                <div className="flex-1">
                  <h3 className="text-foreground font-semibold mb-1">{item.title}</h3>
                  <p className="text-sm text-muted-foreground mb-3">{item.description}</p>
                  <a
                    href={item.action}
                    className="inline-flex items-center gap-2 text-xs text-[#D4AF37] font-semibold hover:underline"
                  >
                    {item.actionLabel}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Response Time */}
        <div className="premium-card p-4 flex items-center gap-3 mb-8">
          <Clock weight="duotone" className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
          <p className="text-sm text-muted-foreground">
            <span className="text-foreground font-medium">Response time:</span> We aim to respond to all inquiries within 24-48 business hours.
          </p>
        </div>

        <SocialFooter />
      </main>
    </div>
  );
};

export default Support;
